import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import PrivacyPolicy from './views/privacy-policy'
import Home from './views/home'
import Homecn from './views/homecn'
import TermsOfService from './views/terms-of-service'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={PrivacyPolicy} exact path="/privacy" />
        <Route component={Home} exact path="/" />
        <Route component={Homecn} exact path="/home_cn" />
        <Route component={TermsOfService} exact path="/terms" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
